import { Properties } from 'csstype';

import { BackgroundCircle } from '@components/atoms/BackgroundCircle/BackgroundCircle';
import { LayoutInner, LayoutWrapper } from '@components/ions/layouts';
import { BreadcrumbsNavigation } from '@components/molecules/BreadcrumbsNavigation/BreadcrumbsNavigation';
import { Footer, FooterProps } from '@components/molecules/Footer/Footer';
import { Header, HeaderProps } from '@components/organisms/Header/Header';

import { useResponsive } from '@utils/hooks/useResponsive';

import {
    ColumnsTemplateColumn,
    ColumnsTemplateContent,
    ColumnsTemplateHeader,
    ColumnsTemplateTitle,
} from './ColumnsLayout.styled';

export interface ColumnsLayoutProps {
    breadcrumb?: string;
    children: React.ReactElement | [React.ReactElement, React.ReactElement];
    className?: string;
    columnsAlign?: Properties['alignItems'];
    contentAlign?: Properties['alignItems'];
    contentPadding?: {
        bottom: number;
        top: number;
    };
    footerProps?: FooterProps;
    headerProps?: HeaderProps;
    title?: string;
}

export const ColumnsLayout = ({
    breadcrumb,
    children,
    className,
    columnsAlign = 'center',
    contentAlign = 'center',
    contentPadding = {
        bottom: 40,
        top: 56,
    },
    footerProps,
    headerProps,
    title,
}: ColumnsLayoutProps) => {
    const isMd = useResponsive('md');
    const firstColumn = Array.isArray(children) ? children[0] : children;
    const secondColumn = Array.isArray(children) ? children[1] : null;

    return (
        <LayoutWrapper className={className}>
            {!isMd && <BackgroundCircle />}
            <LayoutInner>
                <Header {...headerProps} />
                <ColumnsTemplateContent
                    contentAlign={contentAlign}
                    contentPadding={contentPadding}
                >
                    {(title || breadcrumb) && (
                        <ColumnsTemplateHeader>
                            {breadcrumb && (
                                <BreadcrumbsNavigation path={breadcrumb} />
                            )}
                            {title && (
                                <ColumnsTemplateTitle>
                                    {title}
                                </ColumnsTemplateTitle>
                            )}
                        </ColumnsTemplateHeader>
                    )}
                    <ColumnsTemplateColumn columnsAlign={columnsAlign}>
                        {firstColumn}
                    </ColumnsTemplateColumn>
                    <ColumnsTemplateColumn columnsAlign={columnsAlign}>
                        {secondColumn}
                    </ColumnsTemplateColumn>
                </ColumnsTemplateContent>
                <Footer {...footerProps} />
            </LayoutInner>
        </LayoutWrapper>
    );
};
